import './signin.css';
import Authenticated from '../lib/authenticated';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function emailSignIn(toast) {
    const email = document.getElementById("email").value;
    fetch('/v1/api/auth/email', {
        method: 'PUT',
        headers: {
            'Authorization': `Basic ${btoa(email)}`,
        },
    }).then(response => {
        if (response.ok) {
            toast("One-time sign-in link has been sent to your email address.");
        } else {
            toast("Failed to send sign-in link. Please try again.");
        }
    });
}

function passwordSignIn(toast, navigate) {
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    fetch('/v1/api/auth/cookie', {
        method: 'PUT',
        headers: {
            'Authorization': `Basic ${btoa(`${email}:${password}`)}`,
        },
    }).then(response => {
        if (response.ok) {
            navigate('/v1/ui/staff/page/settings');
        } else {
            toast("Failed to sign in. Please check your credentials.");
        }
    });
}

export default function SignIn({children}) {
    const navigate = useNavigate();

    return <Authenticated reverse={true} redirect="/v1/ui/staff/page/settings">
        <div className="signin">
            <div className="panel">
                <input type="email" id="email" placeholder="none@example.com" />
                <button onClick={() => emailSignIn(toast)}>Email Sign In</button>
                <input type="password" id="password" placeholder="secure" />
                <button onClick={() => passwordSignIn(toast, navigate)}>Password Sign In</button>
                <ToastContainer />
            </div>
            <main>
                {children}
            </main>
        </div>
    </Authenticated>;
}
